import React from "react";
import styles from "./no-blueprints-found-table-empty-row.module.scss";
import { useI18N } from "@src/language/language-context";

const cssClassName = "no-blueprints-found-table-empty-row";

export const NoBlueprintsFoundTableEmptyRow = () => {
  const i18n = useI18N();
  return (
    <tr className={styles[cssClassName]}>
      <td colSpan={4} style={{ textAlign: "center" }}>
        {i18n("modules.blueprintsTable.noBlueprintsFound")}
      </td>
    </tr>
  );
};
